import { makeOverline } from './internal/makeOverline';

/**
 * Компонет типогрфики для оформления лейблов в UI
 */
export const Overline = makeOverline({
  fontSize: '10px',
  lineHeight: '4u',
  letterSpacing: '1px'
});